<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<div class="container" fxLayout="column" fxFill>
  <!-- Header -->
  <div id="custom_dialog">
    <span class="dialog_header">{{ title }}</span>
  </div>

  <form [formGroup]="detailsForm" (ngSubmit)="onSubmit()">
    <div fxLayout="row">
      <div fxLayout="column" class="form_box form-row">
        <div fxLayout="column" class="form" fxLayoutGap="16px">
          <div fxLayout="row">
            <mat-form-field appearance="outline">
              <mat-label i18n="label for name@@name">Name</mat-label>
              <input
                matInput
                formControlName="name"
                (input)="onNameInput($event)"
                (keyup)="validateName()"
                class="lowercase-input"
              />
              <mat-hint i18n="label for name hint@@nameHint"
                >The Workflow name cannot be changed after Workflow is created.</mat-hint
              >
              <mat-error
                *ngIf="detailsForm.controls.name.errors?.required"
                i18n="label for name required error@@nameRequiredErr"
                >Name is required</mat-error
              >
              <mat-error
                *ngIf="detailsForm.controls.name.errors?.repeat"
                i18n="label for name already exists error@@nameAlrExistsErr"
                >Name already exists</mat-error
              >
              <mat-error
                *ngIf="detailsForm.controls.name.errors?.invalidCharacters"
                i18n="label for name invalid characters error@@nameInvalidCharsErrCreation"
                >Name can't contain any of the following characters: . + * ? ^ $ ( ) [ ] {{ '{' }}
                {{ '}' }} | \ = & / &#64; : % < ></mat-error
              >
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <mat-form-field appearance="outline">
              <mat-label i18n="label for description creation@@descriptionCreation"
                >Description (optional)</mat-label
              >
              <textarea matInput formControlName="description" rows="3"> </textarea>
            </mat-form-field>
          </div>
        </div>

        <!-- Create Workflow Button -->
        <div fxLayout="row" fxLayoutGap="16px" class="action-buttons">
          <button mat-raised-button class="cancel-button" type="button" (click)="cancelClicked()">
            <span>{{ cancelButtonText }}</span>
          </button>
          <button
            mat-raised-button
            color="primary"
            type="button"
            [disabled]="!detailsForm.valid || isCreating"
            (click)="createWorkflowInDesigner()"
          >
            <span *ngIf="!isCreating" i18n="@@createAndOpenDesigner">Create Workflow</span>
            <span *ngIf="isCreating" i18n="@@creating">Creating...</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
